import { loadScript } from "./script";

let inited = false;

export async function loadYandexLoginScript() {
    if (!inited) {
        await loadScript('https://yastatic.net/s3/passport-sdk/autofill/v1/sdk-suggest-with-polyfills-latest.js');
        inited = true;
    }
}